import { useNavigate } from 'react-router-dom';
import Loading from '../components/Loading';
import { useGetLudoInplayRoundsQuery } from '../services/ludo/ludoApi';

const getGameRoute = (game) => {
  const name = (game.name || '').toLowerCase();
  if (name.includes('roulette')) return `/roulette/live/${game.id}`;
  if (name.includes('aviator'))  return `/ludo/live/aviator`;
  return `/ludo/live/${game.id}`;
};

const InplayLudoPage = () => {
  const navigate = useNavigate();

  const { data, isLoading, error } = useGetLudoInplayRoundsQuery();
  const games = data?.data || [];

  return (
    <div className="w-full">
      <div className="flex justify-center">
        <div className="w-full px-2">
          <div className="bg-white rounded shadow border border-gray-200">
            <div className="bg-gray-600 px-5 py-2 flex items-center justify-between">
              <span className="text-xl text-white font-normal capitalize">Active Games</span>
              <button onClick={() => navigate(-1)} className="bg-white text-gray-700 px-4 py-1 hover:bg-gray-100" style={{ borderRadius: 0 }}>
                Back
              </button>
            </div>

            <div className="overflow-x-auto">
              {isLoading ? (
                <div className="flex justify-center py-8"><Loading /></div>
              ) : error ? (
                <div className="p-4 text-red-500 text-center">{error?.message || 'Failed to load'}</div>
              ) : (
                <table className="w-full border-collapse text-sm">
                  <thead>
                    <tr className="bg-gray-600 text-white">
                      <th className="p-3 border border-gray-500 text-left font-medium">#</th>
                      <th className="p-3 border border-gray-500 text-left font-medium">Name</th>
                      <th className="p-3 border border-gray-500 text-left font-medium">Current Round</th>
                      <th className="p-3 border border-gray-500 text-left font-medium">Status</th>
                      <th className="p-3 border border-gray-500 text-left font-medium">Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {games.length === 0 ? (
                      <tr>
                        <td colSpan={5} className="p-8 text-center text-gray-500">No active games found</td>
                      </tr>
                    ) : (
                      games.map((game, index) => (
                        <tr key={game.id || index} className="hover:bg-gray-50 border-b border-gray-200">
                          <td className="p-3 border border-gray-300 text-gray-800">{index + 1}</td>
                          <td className="p-3 border border-gray-300 font-medium text-gray-800">{game.name}</td>
                          <td className="p-3 border border-gray-300 text-xs text-gray-500">{game.currentRound || '-'}</td>
                          <td className="p-3 border border-gray-300">
                            <span className={`px-2 py-0.5 text-xs rounded font-medium ${game.betOpen ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-700'}`}>
                              {game.betOpen ? 'Bet Open' : 'Bet Closed'}
                            </span>
                          </td>
                          <td className="p-3 border border-gray-300">
                            <div className="flex gap-2">
                              <button
                                onClick={() => navigate(getGameRoute(game))}
                                className="bg-green-600 text-white px-4 py-1.5 hover:bg-green-700 transition-colors text-sm"
                                style={{ borderRadius: 0 }}
                              >
                                View
                              </button>
                            </div>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InplayLudoPage;
